import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { Menu } from "lucide-react";
import Logo from "@/components/common/Logo";

const BuyerAuthHeader = () => {
  const location = useLocation();
  const isRegisterPage = location.pathname === "/buyer/register";
  
  return (
    <header className="border-b border-gray-800 bg-[#080c14] pt-[env(safe-area-inset-top)]">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Logo className="text-[#ffd700]" context="buyer" />
        <div className="flex items-center gap-4">
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/seller" className="text-gray-300 hover:text-[#ffd700] transition-colors">
              For Sellers
            </Link>
            <Link to="/blog" className="text-gray-300 hover:text-[#ffd700] transition-colors">
              Blog
            </Link>
            <Link to="/buyer/faq" className="text-gray-300 hover:text-[#ffd700] transition-colors">
              FAQ
            </Link>
            <Link to="/contact" className="text-gray-300 hover:text-[#ffd700] transition-colors">
              Contact
            </Link>
            {isRegisterPage ? (
              <Link to="/buyer/login" className="text-gray-300 hover:text-[#ffd700] transition-colors">
                Sign In
              </Link>
            ) : (
              <Link to="/buyer/register">
                <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
                  Create Free Account
                </Button>
              </Link>
            )}
          </nav>

          {/* Mobile Dropdown Menu */}
          <div className="md:hidden">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
                  <Menu className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent 
                className="w-56 bg-gray-900 border-gray-700 z-50" 
                align="end"
              >
                <DropdownMenuItem asChild>
                  <Link to="/seller" className="w-full cursor-pointer text-gray-300 hover:text-[#ffd700]">
                    For Sellers
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/blog" className="w-full cursor-pointer text-gray-300 hover:text-[#ffd700]">
                    Blog
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/buyer/faq" className="w-full cursor-pointer text-gray-300 hover:text-[#ffd700]">
                    FAQ
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/contact" className="w-full cursor-pointer text-gray-300 hover:text-[#ffd700]">
                    Contact
                  </Link>
                </DropdownMenuItem>
                {isRegisterPage ? (
                  <DropdownMenuItem asChild>
                    <Link to="/buyer/login" className="w-full cursor-pointer text-gray-300 hover:text-[#ffd700]">
                      Sign In
                    </Link>
                  </DropdownMenuItem>
                ) : (
                  <DropdownMenuItem asChild>
                    <Link to="/buyer/register" className="w-full cursor-pointer text-[#ffd700]">
                      Create Free Account
                    </Link>
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BuyerAuthHeader;
